import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d74895c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading_page_box" }
const _hoisted_2 = { class: "imgContainer" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Autenticando usuário...", -1))
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"boxes\" data-v-d74895c6><div class=\"box\" data-v-d74895c6><div data-v-d74895c6></div><div data-v-d74895c6></div><div data-v-d74895c6></div><div data-v-d74895c6></div></div><div class=\"box\" data-v-d74895c6><div data-v-d74895c6></div><div data-v-d74895c6></div><div data-v-d74895c6></div><div data-v-d74895c6></div></div><div class=\"box\" data-v-d74895c6><div data-v-d74895c6></div><div data-v-d74895c6></div><div data-v-d74895c6></div><div data-v-d74895c6></div></div><div class=\"box\" data-v-d74895c6><div data-v-d74895c6></div><div data-v-d74895c6></div><div data-v-d74895c6></div><div data-v-d74895c6></div></div></div><div class=\"developedBy\" data-v-d74895c6>Desenvolvido por Implanta It</div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "cliente_imagem",
        src: _ctx.imgCliente,
        alt: "logo_empresa"
      }, null, 8, _hoisted_3),
      _hoisted_4
    ]),
    _hoisted_5
  ]))
}